import React from "react";

import "./index.css";

import ColorPricingCategoryContainer from "./colorPricingCategoryTableContainer";
import { ColorPricingCategoryContextProvider } from "../../../../contexts/color-pricing-category.context";

function ColorPricingCategory(props) {
  return (
    <ColorPricingCategoryContextProvider>
      <div className="deco-container">
        <ColorPricingCategoryContainer />
      </div>
    </ColorPricingCategoryContextProvider>
  );
}

export default ColorPricingCategory;
